<template>
  <div class="cp-backoffice-icon-set">
    <ValidationProvider
      :vid="'icon-set-image' + vid"
      slim
      rules="required"
      :name="imageFieldName"
      v-slot="{ errors }"
    >
      <!-- eslint-disable-next-line vue/valid-v-model -->
      <div v-model="imageModel">
        <Upload :url="image" @add-image="updateImage" @change-image="updateImage" />
        <p v-if="errors[0]" class="help is-danger">{{ errors[0] }}</p>
      </div>
    </ValidationProvider>
    <ValidationProvider
      :vid="'icon-set-text' + vid"
      slim
      rules="required"
      :name="textFieldName"
      v-slot="{ errors }"
    >
      <b-input class="cp-backoffice-icon-set-input" v-model="textModel"></b-input>
      <p v-if="errors[0]" class="help is-danger">{{ errors[0] }}</p>
    </ValidationProvider>
    <ValidationProvider
      :vid="'icon-set-text-en' + vid"
      slim
      rules=""
      :name="textFieldNameEn"
      v-slot="{ errors }"
    >
      <b-input class="cp-backoffice-icon-set-input" v-model="textModelEn"></b-input>
      <p v-if="errors[0]" class="help is-danger">{{ errors[0] }}</p>
    </ValidationProvider>
  </div>
</template>

<script>
import Upload from '@/components/backoffice/Upload.vue';

export default {
  name: 'IconSet',
  components: {
    Upload,
  },
  props: {
    vid: {
      type: String,
      default: '',
    },
    imageFieldName: {
      type: String,
      default: '',
    },
    textFieldName: {
      type: String,
      default: '',
    },
    textFieldNameEn: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textEn: {
      type: String,
      default: '',
    },
  },
  computed: {
    imageModel: {
      get() {
        return this.image;
      },
      set(url) {
        this.$emit('update:image', url);
      },
    },
    textModel: {
      get() {
        return this.text;
      },
      set(text) {
        this.$emit('update:text', text);
      },
    },
    textModelEn: {
      get() {
        return this.textEn;
      },
      set(text) {
        this.$emit('update:textEn', text);
      },
    },
  },
  methods: {
    updateImage(url) {
      this.$emit('update:image', url);
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-backoffice-icon-set {
  &-input {
    margin-top: 10px;
    width: 200px;
  }
}
</style>
